import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { modosEnviosBoletos } from '../cliente-modo-envio-boleto';

@Component({
    selector: 'sgt-cliente-modo-envio-boleto-select',
    templateUrl: './cliente-modo-envio-boleto-select.component.html',
    styleUrls: ['./cliente-modo-envio-boleto-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ClienteModoEnvioBoletoSelectComponent), multi: true },
    ]
})
export class ClienteModoEnvioBoletoSelectComponent {
    /** ID do modo de envio de boletos para os clientes */
    @Input() ngModel: number;
    /** Ao alterar o modo de envio de boletos para os clientes */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Modos de envios de boletos disponíveis no select */
    modos = modosEnviosBoletos;

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    /** Ao alterar o modo de envio dos boletos */
    onChange(id: number) {
        this.ngModel = id;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
